<div class="error-container" aria-live="assertive">
  <div class="alert valign-children-middle" *ngIf="errorMessage">
    <div class="alert-error" aria-label="Alert.">
      <i class="icon-badgealert" aria-hidden="true"></i>
    </div>
    <div>
      <h2>Something isn't working</h2>
      <p>{{ this.errorMessage }</p>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-12 col-md-6 col-md-offset-3 break-text" *ngIf="userWizardObj !== null">
    <p *ngIf="!assignFlag"><label class="data-label">Selected action:</label> Un-assign licenses</p>
    <p *ngIf="assignFlag"><label class="data-label">Selected action:</label> Assign licenses</p>
    <div *ngFor="let product of userWizardObj.selectedProductList">
      <div><label class="data-label" *ngIf="!singleUser">Selected product: </label> <label *ngIf="singleUser">Selected products: </label><span>{{product.productName}}</span></div>
      <div><label class="data-label">Foundation account:</label> <span>{{product.selectedFan}}</span></div>
      <div><label class="data-label">Wireless number:</label> <span>{{product.selectedCtn}}</span></div>
      <p><span>{{product.licensegroupName && product.licensegroupName}}</span></p>
    </div>

    <p *ngIf="!singleUser"><label class="data-label">Selected users:</label> <span *ngIf="assignFlag">{{selectedUsersCount}} users selected</span></p>
    <p><label class="data-label" *ngIf="singleUser && !assignFlag">Selected user</label></p>

    <div class="tiny-accordion unassign-panel" *ngIf="!assignFlag">
      <div *ngIf="userWizardObj.selectedUserList.length > 1">
        <div class="toggle-header" [ngClass]="{'toggle-header-open':accordionflag}">
          <a href="javascript:void(0)" (click)="openAccordion()" aria-controls="unassignPanel" [attr.aria-label]="accordionflag ? selectedUsersCount + ' users selected. Expand list of selected users.' : selectedUsersCount + ' users selected. Close.'">{{selectedUsersCount}} users selected
            <i *ngIf=accordionflag class="icon-accordion-plus" aria-hidden="true"></i>
            <i *ngIf=!accordionflag aria-hidden="true" class="icon-accordion-minus"></i>
          </a>
        </div>
        <div class="panel" [class.showpanel]="accordionflag" id="unassignPanel">
          <ul class="user-details">
            <li *ngFor="let user of userWizardObj.selectedUserList"><span class="user-name">{{user.firstName}}</span><span class="user-email">{{user.email}}</span></li>
          </ul>
        </div>
      </div>
      <div *ngIf="userWizardObj.selectedUserList.length === 1">
        <div class="panel" *ngFor="let user of userWizardObj.selectedUserList">
          <ul class="user-details">
            <li><span class="user-name">{{user.firstName}}</span><span class="user-email">{{user.email}}</span></li>
          </ul>
        </div>
      </div>
    </div>
    <div *ngIf="(assignFlag && singleUser)">
      <label class="data-label">Selected user: </label> {{userWizardObj.selectedUserList[0].firstName}}
      <p class="break-all"><label class="data-label">Email: </label>{{userWizardObj.selectedUserList[0].email}}</p>
    </div>
    <!-- multiple suer selected end -->
    <!-- product info start -->
    <!--single product assign multiple user start-->
    <div *ngIf="assignFlag">
      <div *ngIf="!singleUser">
        <p><label class="data-label">Required information:</label></p>
        <div class="tiny-accordion">
          <div *ngFor="let user of userWizardObj.selectedUserList;let i = index">
            <div class="toggle-header" [ngClass]="{'toggle-header-open':accordionList[i]}">
              <a href="javascript:void(0)" [attr.aria-controls]="'assignPanel' + i" (click)="openAccordion(i)" [attr.aria-label]="accordionList[i] ? user.firstName + '. Hide details' : user.firstName + '. Show details' ">{{user.firstName}}
                <i *ngIf=!accordionList[i] aria-hidden="true" class="icon-accordion-plus"></i>
                <i *ngIf=accordionList[i] aria-hidden="true" class="icon-accordion-minus"></i>
            </a>
            </div>
            <div class="panel" [attr.id]="'assignPanel' + i" [attr.aria-hidden]="!accordionList[i]" *ngIf="accordionList[i]" [ngClass]="{'showpanel':!accordionList[i]}">
              <p class="break-all">{{user.email}}</p>
              <div *ngIf="user.formConfigurations">
                <div *ngIf="user.formProperties.length > 0">
                  <div *ngFor="let formprop of user.formProperties;let j=index">
                    <span>{{formprop.label}} </span><a *ngIf="j === 0" href="javascript:void(0)" (click)="edit(i)">edit</a>
                    <p>{{formprop.value}}</p>
                  </div>
                </div>
                <div *ngIf="user.formProperties.length==0">
                  <app-form-builder [formConfig]="user.formConfigurations" [formName]="user.clientId" (formOutput)="getFormConfigDetails($event,user.clientId,i)"></app-form-builder>
                </div>
                <button class="btn btn-secondary btn-sm-block review-btn" [disabled]="!formConfiguration.formProperty[i].formStatus" (click)="next(i)"
                  *ngIf="(userArraylength-1)!=i && nextButtonFlag[i]" aria-label="Continue.">Continue</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--single product assign multiple user end -->
      <!-- multiple product single user assign-->
      
      <div *ngIf="singleUser">
        <div *ngFor="let productConfig of configuration;let i = index">
          <div *ngIf='productConfig.licenseConfigurations.length > 0'>
            <h2 class="review-page-title" *ngIf="i === 0">Required Information:</h2>
            <p><span *ngIf="productConfig.displayName">{{productConfig.displayName}}</span></p>
            <app-form-builder [formConfig]="productConfig.licenseConfigurations" [formName]="productConfig.dcmCode" (formOutput)="getFormConfigDetails($event,singleUser,i,productConfig.dcmCode)"></app-form-builder>
          </div>
        </div>
      </div>
      <!-- multiple product single user assign end-->
    </div>
    <!-- multiple suer selected end -->

    <div class="line-footer text-right review-unassign">
      <button class="btn btn-secondary btn-sm-block pull-right" (click)=assignUnassign() [checkImpersonator]="!assignUnassignButtonFlag || csrPermissionAssignUnassignButton"
        *ngIf="!assignFlag" aria-label="Un-assign.">Un-assign</button>
      <button class="btn btn-secondary btn-sm-block pull-right" (click)=assignUnassign() [checkImpersonator]="!assignUnassignButtonFlag || csrPermissionAssignUnassignButton"
        *ngIf="assignFlag" aria-label="Assign.">Assign</button>
      <a href="javascript:void(0)" class="btn btn-sm-block btn-link" (click)="cancel()">Back</a>
    </div>
  </div>
</div>